// VIDEO SLIDER -- START
$('.video-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: false,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M20.5465 9.88L14.4398 16L20.5465 22.12L18.6665 24L10.6665 16L18.6665 8L20.5465 9.88Z" fill="#040F30"/></svg></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M11.4535 9.88L17.5602 16L11.4535 22.12L13.3335 24L21.3335 16L13.3335 8L11.4535 9.88Z" fill="#040F30"/></svg></button>',
    responsive: [
      {
        breakpoint: 1220,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          infinite: true,
          arrows: false,
          centerMode: true,
        }
      }
    ]
});
$('.product-review-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: true,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M16.6667 10H3.33342M3.33342 10L8.33341 5M3.33342 10L8.33341 15" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3.33325 10H16.6666M16.6666 10L11.6666 5M16.6666 10L11.6666 15" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          infinite: true,
          arrows: false,
          centerMode: true,
          centerPadding: '20px',
        }
      }
    ]
});
// VIDEO SLIDER -- END

// SUBSCRIPTION USPs -- START

$(document).ready(function () {
  var intervalId = setInterval(function(){
    if(jQuery('[name="purchaseOption"]').length>0){
      var valueOption = jQuery('[name="purchaseOption"]:checked').val();
      subscirbeHtml(valueOption);
      clearInterval(intervalId);
    }
  },500);
});

jQuery(document).on("change","[name='purchaseOption']",function(){
  var valueOption = jQuery(this).val();
  setTimeout(function(){
    subscirbeHtml(valueOption);
  },500);
});
function subscirbeHtml(val) {
  //if (val === 'subscription') {
    if (jQuery('.recharge-subscription-widget').length !== 0) {
      let percentageOff = 0;
      const intervalId = setInterval(() => {
        const widget = jQuery('.shopify-block.shopify-app-block.recharge-subscription-widget');
        const subscriptionText = widget.find('.rc-radio__price').text()?.trim();
        if (subscriptionText) {
          var mainPrice = jQuery("[name='Select quantity']:checked").parent('div').find('.vprice').text();
          const mainPriceData = mainPrice.match(/[\d.]+/);
          const matchedPercentage = subscriptionText.match(/[\d.]+/);
          if(mainPriceData!=null){
            if (matchedPercentage && matchedPercentage[0] && mainPriceData[0]) {
              jQuery('.subsave-usps').remove();
              var pricemain = mainPriceData[0];
              percentageOff = parseFloat(parseFloat(pricemain)-parseFloat(matchedPercentage[0]));
              //console.log("percentageOff",percentageOff);
              percentageOff = Math.round(percentageOff*100);
              percentageOff = Shopify.formatMoney(percentageOff);
              percentageOff = percentageOff.replace(/\.00/g, '');
              widget.find('.rc-radio__subscription').text('Subscribe & Save '+percentageOff);
              clearInterval(intervalId);
              jQuery('.recharge-subscription-widget .subscription-radio').append(`
              <ul class="subsave-usps">
                <li>Save <span class="percentage-save">${percentageOff}</span> on every order</li>
                <li>FREE shipping on all orders</li>
                <li>Pause, update frequency or cancel anytime</li>
              </ul>
            `);
            }    
          }
        }
        // $('.rc-radio__subscription').each(function() {
        //     const text = $(this).html();
        //     const updatedText = text.replace(/& Save {percentageOff}%/, '<b>& Save {percentageOff}%</b>');
        //     $(this).html(updatedText);
        // });
      }, 100);
    // }
  }
}

function subscirbeHtml_percentage(val) {
  if (val === 'subscription') {
    if (jQuery('.recharge-subscription-widget').length !== 0) {
      
      let percentageOff = '25';
      const intervalId = setInterval(() => {
        const widget = jQuery('.shopify-block.shopify-app-block.recharge-subscription-widget');
        const subscriptionText = widget.find('.rc-radio__subscription').text()?.trim();

        if (subscriptionText) {
          const matchedPercentage = subscriptionText.match(/[\d.]+/);
          if (matchedPercentage && matchedPercentage[0]) {
            jQuery('.subsave-usps').remove();
            percentageOff = matchedPercentage[0];
            const updatedText = subscriptionText.replace(`${percentageOff}%`, '');
            // widget.find('.rc-radio__subscription').text(updatedText);
            clearInterval(intervalId);
            jQuery('.recharge-subscription-widget .subscription-radio').append(`
            <ul class="subsave-usps">
              <li>Save <span class="percentage-save">${percentageOff}%</span> on every order</li>
              <li>FREE shipping on all orders</li>
              <li>Pause, update frequency or cancel anytime</li>
            </ul>
          `);
          }        
        }
        // $('.rc-radio__subscription').each(function() {
        //     const text = $(this).html();
        //     const updatedText = text.replace(/& Save {percentageOff}%/, '<b>& Save {percentageOff}%</b>');
        //     $(this).html(updatedText);
        // });
      }, 500);
    }
  }
}

// SUBSCRIPTION USPs -- END

//PRODUCT DETAILS PAGE FOR CHANGE VARIANT FOR ADD CLASS BODY AND DETAILS SOME CHANGES START
let priceVariant=0;
let goalAmount=70;
jQuery(document).ready(function(){
  if(jQuery("[name='Select Flavor']").length > 0){
    jQuery("[name='Select Flavor']:checked").trigger('change');
  }
});

jQuery(document).on("change","[name='Select Flavor']",function(e){
  e.preventDefault();
  e.stopPropagation();
  var selectedFlover = jQuery(this).val();
  classAddBodyFlover(selectedFlover);
  if(jQuery('.feature-product-blocks__image').length != 0){
    updateProductBenifitImg(selectedFlover);
  }
    if(jQuery('.step-section-top-image').length != 0){
    updateProductBenifitImg(selectedFlover);
  }
  if(jQuery('.product-variant-custom').find('.variant-wrapper.variant_name-select-quantity').length>0){
    updatePackCards();
  }
});

jQuery(document).on('change', '.product-variant-custom .variant-input-wrap:not([data-handle="select-quantity"]) input[type="radio"]', function() {
  if(jQuery('.product-variant-custom .variant-wrapper.variant_name-select-quantity').length > 0){
    updatePackCards();
  }
});

jQuery(document).ready(function(){
  var classInter = setInterval(function(){
    if(jQuery("[name='Select Flavor']").length!=0){
      var selectedFlover = jQuery("[name='Select Flavor']:checked").val();
      classAddBodyFlover(selectedFlover);
      clearInterval(classInter);
      if(jQuery('.custom_default_variant').length>0){
        var gummiesGet = jQuery("[data-index='option1'] input[type='radio']:checked").parent('div').find('.price-wrapper').attr('data-gummies');
        var price = jQuery("[data-index='option1'] input[type='radio']:checked").parent('div').find('.vprice').attr('data-price');
        var servingprice = jQuery("[data-index='option1'] input[type='radio']:checked").parent('div').find('.price-wrapper').attr('data-servingprice');
        var serviceDays = jQuery("[data-index='option1'] input[type='radio']:checked").parent('div').find('.price-wrapper').attr('data-serviceDays');
        if(gummiesGet !== undefined && gummiesGet !== '') {
          gummiesProductData(gummiesGet,price, servingprice, serviceDays);
        }
        setGummiesServing();
      }
    }
  },1000);
});

jQuery(window).bind('load',function(){
  if(jQuery('body').hasClass('flover_default')){
    var gummiesGet = jQuery("[data-index='option2'] input[type='radio']:checked").parent('div').find('.price-wrapper').attr('data-gummies');
    var price = jQuery("[data-index='option2'] input[type='radio']:checked").parent('div').find('.vprice').attr('data-price');
    var servingprice = jQuery("[data-index='option2'] input[type='radio']:checked").parent('div').find('.price-wrapper').attr('data-servingprice');
    var serviceDays = jQuery("[data-index='option2'] input[type='radio']:checked").parent('div').find('.price-wrapper').attr('data-serviceDays');
    gummiesProductData(gummiesGet,price, servingprice, serviceDays);
    setGummiesServing();
  }
});
jQuery(document).on("change","[name='Select quantity'] input[type='radio']",function(e){
  e.preventDefault();
  e.stopPropagation();
  var gummiesGet = jQuery(this).parent('div').find('.price-wrapper').attr('data-gummies');
  var servingprice = jQuery(this).parent('div').find('.price-wrapper').attr('data-servingprice');
  var price = jQuery(this).parent('div').find('.vprice').attr('data-price');
  var serviceDays = jQuery("[name='Select quantity']:checked").parent('div').find('.price-wrapper').attr('data-serviceDays');
  gummiesProductData(gummiesGet,price, servingprice, serviceDays);
  var valueOption = jQuery('[name="purchaseOption"]:checked').val();
  //setTimeout(function(){
    subscirbeHtml(valueOption);
  //},500);
});

function updateProductBenifitImg(colorflover) {
  var colorflover = colorflover.split(' ');
  var floverClass='';
  if(colorflover.length>0){
    for(var r=1;r<colorflover.length;r++){
      floverClass+=colorflover[r]+'_';
    }
  }

  floverClass = floverClass.replace(/_$/, "").toLowerCase();
  if(floverClass=='blue_raspberry'){
    var flavoutImg = jQuery('.feature-product-blocks__image').find('img').attr('data-raspberry');
    var topflavoutImg = jQuery('.product-step-section-top-image').find('img').attr('data-raspberry');
  }
  else if(floverClass=='sweet_strawberry'){
    var flavoutImg = jQuery('.feature-product-blocks__image').find('img').attr('data-strawberry');
    var topflavoutImg = jQuery('.product-step-section-top-image').find('img').attr('data-strawberry');
  }
  else if(floverClass=='fruit_punch'){
    var flavoutImg = jQuery('.feature-product-blocks__image').find('img').attr('data-fruitpunch');
    var topflavoutImg = jQuery('.product-step-section-top-image').find('img').attr('data-fruitpunch');
  }
  else if(floverClass=='lemonade_squeeze'){
    var flavoutImg = jQuery('.feature-product-blocks__image').find('img').attr('data-lemonadesweeze');
    var topflavoutImg = jQuery('.product-step-section-top-image').find('img').attr('data-lemonadesweeze');
  }
  else if(floverClass=='peach_rings'){
    var flavoutImg = jQuery('.feature-product-blocks__image').find('img').attr('data-peachrings');
    var topflavoutImg = jQuery('.product-step-section-top-image').find('img').attr('data-peachrings');
  }
  else if(floverClass=='watermelon_splash'){
    var flavoutImg = jQuery('.feature-product-blocks__image').find('img').attr('data-watermelonsplash');
    var topflavoutImg = jQuery('.product-step-section-top-image').find('img').attr('data-watermelonsplash');
  }
  jQuery('.feature-product-blocks__image').find('img').attr('src', flavoutImg);
  jQuery('.product-step-section-top-image').find('img').attr('src', topflavoutImg);
  
}

function floverWisePackImageSet(flovername){
  if(flovername!="" && flovername!=undefined){
    var flovername = flovername.split(' ');
    var floverClass='';
    if(flovername.length>0){
      for(var r=1;r<flovername.length;r++){
        floverClass+=flovername[r]+'_';
      }
    }

    floverClass = floverClass.replace(/_$/, "").toLowerCase();
    var imageName = ''
    if(floverClass=='blue_raspberry'){
      imageName='sweet-blue-pack';
    }
    else if(floverClass=='sweet_strawberry'){
      imageName='strawberry';
    }
    else if(floverClass=='fruit_punch'){
    imageName='punch';
    }
    else if(floverClass=='lemonade_squeeze'){
    imageName='pink';
    }
    else if(floverClass=='peach_rings'){
      imageName='peach';
    }
    else if(floverClass=='watermelon_splash'){
      imageName = 'water';
    }
    //console.log("product-variant-custom",imageName);
    if(imageName!=""){
      if(jQuery('.product-variant-custom').find('.variant-wrapper.variant_name-select-quantity').length>0){
        var indeximg=1;
        jQuery('.product-variant-custom').find('.variant-wrapper.variant_name-select-quantity .variant-input').each(function(){
          var imgPack = '//getbeastbites.com/cdn/shop/files/'+imageName+'-'+indeximg+'.png';
          jQuery(this).find('.variant-option-image').find('img').attr('src',imgPack);
          indeximg++;
        });
      }
    }
  }
}

function updatePackCards() {
  var $quantityWrapper = jQuery('.product-variant-custom .variant-wrapper.variant_name-select-quantity');
  if (!$quantityWrapper.length) return;

  var currentOpts = {};
  jQuery('.product-variant-custom .variant-input-wrap').each(function() {
    var idx = jQuery(this).attr('data-index');
    var val = jQuery(this).find('input[type="radio"]:checked').val();
    if (idx && val !== undefined) {
      currentOpts[idx] = val;
    }
  });

  $quantityWrapper.find('.variant-input').each(function() {
    var $card = jQuery(this);
    var packOptionIndex = $card.attr('data-index');
    var packVariants = [];
    try {
      packVariants = JSON.parse($card.attr('data-pack-variants') || '[]');
    } catch(e) {
      return;
    }
    if (!packVariants.length) return;

    var match = null;
    for (var i = 0; i < packVariants.length; i++) {
      var v = packVariants[i];
      var allMatch = true;
      for (var optKey in currentOpts) {
        if (optKey === packOptionIndex) continue;
        var pos = parseInt(optKey.replace('option', ''));
        var vVal = pos === 1 ? v.option1 : (pos === 2 ? v.option2 : v.option3);
        if (vVal !== currentOpts[optKey]) {
          allMatch = false;
          break;
        }
      }
      if (allMatch) { match = v; break; }
    }
    if (!match) return;

    var $img = $card.find('.variant-option-image img');
    if ($img.length && match.image) {
      $img.attr('src', match.image);
    }

    var $vprice = $card.find('.vprice');
    if ($vprice.length) {
      $vprice.text(Shopify.formatMoney(match.price));
      $vprice.attr('data-price', match.price);
      if (match.compare_at_price > match.price) {
        $vprice.addClass('sale-price').removeClass('regular-price');
      } else {
        $vprice.removeClass('sale-price').addClass('regular-price');
      }
    }

    var $comparePrice = $card.find('.regular-price:not(.vprice)');
    if ($comparePrice.length) {
      if (match.compare_at_price > match.price) {
        $comparePrice.find('del').text(Shopify.formatMoney(match.compare_at_price));
        $comparePrice.attr('data-cprice', match.compare_at_price);
        $comparePrice.show();
      } else {
        $comparePrice.hide();
      }
    }

    var $priceWrapper = $card.find('.price-wrapper');
    if ($priceWrapper.length) {
      var serviceDaysRaw = $priceWrapper.attr('data-serviceDays') || $priceWrapper.attr('data-servicedays');
      var divBy =
        parseInt(match.supply_days, 10) ||
        parseInt(serviceDaysRaw, 10) ||
        30;
      if (divBy < 1) {
        divBy = 30;
      }
      if (match.gummies > 0) {
        $priceWrapper.attr('data-gummies', match.gummies);
      }
      $priceWrapper.attr('data-serviceDays', String(divBy));
      var svcPrice = Math.floor(match.price / divBy);
      var svcFormatted = Shopify.formatMoney(svcPrice);
      $priceWrapper.attr('data-servingprice', svcFormatted);
      $card.find('.price-servings').text(svcFormatted + '/serving');
    }
  });

  var $checkedPack = $quantityWrapper.find('input[type="radio"]:checked');
  if ($checkedPack.length) {
    var $parentDiv = $checkedPack.parent('div');
    var gummiesGet = $parentDiv.find('.price-wrapper').attr('data-gummies');
    var servingprice = $parentDiv.find('.price-wrapper').attr('data-servingprice');
    var price = $parentDiv.find('.vprice').attr('data-price');
    var serviceDays = $parentDiv.find('.price-wrapper').attr('data-serviceDays');
    gummiesProductData(gummiesGet, price, servingprice, serviceDays);
  }
}

function classAddBodyFlover(colorflover){
  if(colorflover!="" && colorflover!=undefined){
    var colorflover = colorflover.split(' ');
    var floverClass='';
    if(colorflover.length>0){
      for(var r=1;r<colorflover.length;r++){
        floverClass+=colorflover[r]+'_';
      }
    }
    floverClass = floverClass.replace(/_$/, "").toLowerCase();
    if(jQuery('.custom_default_variant').length>0){
      if(floverClass=='blue_raspberry'){
        document.documentElement.style.setProperty( "--primary-color", "#00C3BD" );
        document.documentElement.style.setProperty( "--secondary-color", "#E5FFFF");
        document.documentElement.style.setProperty( "--tertiary-color", "#F7FFFF");
        document.documentElement.style.setProperty("--label-color", "#C5F5F5");
        document.documentElement.style.setProperty("--product-gradient-color1", "#DAFFFF");
        document.documentElement.style.setProperty("--product-gradient-color2", "#E8FFFF");
        document.documentElement.style.setProperty("--announcment-gradient-color1", "#044B54");
        document.documentElement.style.setProperty("--announcment-gradient-color2", "#00C3BD");
        document.documentElement.style.setProperty("--product-thumb-color", "#C5FFFF");
        
        document.documentElement.style.setProperty("--product-set-first", "#044b54");
        document.documentElement.style.setProperty("--product-set-second", "#000808");
      }
      else if(floverClass=='sweet_strawberry' || floverClass == 'simply_sweet_strawberry'){
        document.documentElement.style.setProperty( "--primary-color", "#E00909");
        document.documentElement.style.setProperty( "--secondary-color", "#FFEDED");
        document.documentElement.style.setProperty( "--tertiary-color", "#FFFAFA");
        document.documentElement.style.setProperty( "--label-color", "#FFD6D6");
        document.documentElement.style.setProperty("--product-gradient-color1", "#FFEAF3");
        document.documentElement.style.setProperty("--product-gradient-color2", "#FFEAF3");
        document.documentElement.style.setProperty("--announcment-gradient-color1", "#910000");
        document.documentElement.style.setProperty("--announcment-gradient-color2", "#C60000");
        document.documentElement.style.setProperty("--product-thumb-color", "#FFC4DC");
        
        document.documentElement.style.setProperty("--product-set-first", "#7F0404");
        document.documentElement.style.setProperty("--product-set-second", "#100000");
        
      }
      else if(floverClass=='fruit_punch'){
        document.documentElement.style.setProperty( "--primary-color", "#EF8225");
        document.documentElement.style.setProperty( "--secondary-color", "#FFF0E2");
        document.documentElement.style.setProperty( "--tertiary-color", "#FFF8F1");
        document.documentElement.style.setProperty("--label-color", "#FFDFC3");
        document.documentElement.style.setProperty("--product-gradient-color1", "#FFFCD9");
        document.documentElement.style.setProperty("--product-gradient-color2", "#FFFCD9" );
        document.documentElement.style.setProperty("--announcment-gradient-color1", "#B45200");
        document.documentElement.style.setProperty("--announcment-gradient-color2", "#EF8225");
        document.documentElement.style.setProperty("--product-thumb-color", "#FFF5B8");
        
        document.documentElement.style.setProperty("--product-set-first", "#C16517");
        document.documentElement.style.setProperty("--product-set-second", "#341801");
      }
      else if(floverClass=='lemonade_squeeze'){
        document.documentElement.style.setProperty(  "--primary-color", "#DD43A0");
        document.documentElement.style.setProperty(  "--secondary-color",  "#FEF0FF");
        document.documentElement.style.setProperty( "--tertiary-color", "#FFF7FF");
        document.documentElement.style.setProperty("--label-color", "#FDDAFF");
        document.documentElement.style.setProperty("--product-gradient-color1", "#FEE8FF");
        document.documentElement.style.setProperty("--product-gradient-color2", "#FEE8FF" );
        document.documentElement.style.setProperty("--announcment-gradient-color1", "#A30D67");
        document.documentElement.style.setProperty("--announcment-gradient-color2", "#DD43A0");
        document.documentElement.style.setProperty("--product-thumb-color", "#EAD2FF");
        
        document.documentElement.style.setProperty("--product-set-first", "#DD43A0");
        document.documentElement.style.setProperty("--product-set-second", "#1A0010");
        
      }
      else if(floverClass=='peach_rings'){
        document.documentElement.style.setProperty( "--primary-color", "#EE4712");
        document.documentElement.style.setProperty( "--secondary-color","#FFEFEB");
        document.documentElement.style.setProperty( "--tertiary-color","#FFF8F6");
        document.documentElement.style.setProperty("--label-color", "#FFD9CE");
        document.documentElement.style.setProperty("--product-gradient-color1", "#FFEDB9");
        document.documentElement.style.setProperty("--product-gradient-color2", "#FFEDB9");
        document.documentElement.style.setProperty("--announcment-gradient-color1", "#CC3404");
        document.documentElement.style.setProperty("--announcment-gradient-color2", "#EE4712");
        document.documentElement.style.setProperty("--product-thumb-color", "#FFECC0");
      
        document.documentElement.style.setProperty("--product-set-first", "#EE4712");
        document.documentElement.style.setProperty("--product-set-second", "#210800");
      }
      else if(floverClass=='watermelon_splash'){
        document.documentElement.style.setProperty("--primary-color", "#28B40C");
        document.documentElement.style.setProperty("--secondary-color", "#E2FFE8");
        document.documentElement.style.setProperty( "--tertiary-color","#F1FFF0");
        document.documentElement.style.setProperty("--label-color", "#C5FFCF");
        document.documentElement.style.setProperty("--product-gradient-color1", "#D3FFD7");
        document.documentElement.style.setProperty("--product-gradient-color2", "#D3FFD7");
        document.documentElement.style.setProperty("--announcment-gradient-color1", "#1EA104");
        document.documentElement.style.setProperty("--announcment-gradient-color2", "#28B40C");
        document.documentElement.style.setProperty("--product-thumb-color", "#D2FFD6");
        
        document.documentElement.style.setProperty("--product-set-first", "#1A8405");
        document.documentElement.style.setProperty("--product-set-second", "#041600");
        
      }
      else if(floverClass=='sleepy_strawberry'){
        document.documentElement.style.setProperty("--primary-color", "#660FC5");
        document.documentElement.style.setProperty("--secondary-color", "#F1E5FF");
        document.documentElement.style.setProperty( "--tertiary-color","#FBF7FF");
        document.documentElement.style.setProperty("--label-color", "#EEDEFF");
        document.documentElement.style.setProperty("--product-gradient-color1", "#D3FFD7");
        document.documentElement.style.setProperty("--product-gradient-color2", "#D3FFD7");
        document.documentElement.style.setProperty("--announcment-gradient-color1", "#660FC5");
        document.documentElement.style.setProperty("--announcment-gradient-color2", "#7921D9");
        document.documentElement.style.setProperty("--product-thumb-color", "#D2FFD6");
        
        document.documentElement.style.setProperty("--product-set-first", "#660FC5");
        document.documentElement.style.setProperty("--product-set-second", "#100022");
      }
    }
    else if(jQuery('body').hasClass('product_sleep-gummies')){
    /* if(floverClass=='blue_raspberry'){
        document.documentElement.style.setProperty( "--primary-color", "#00C3BD" );
        document.documentElement.style.setProperty( "--secondary-color", "#E5FFFF");
        document.documentElement.style.setProperty( "--tertiary-color", "#F7FFFF");
        document.documentElement.style.setProperty("--label-color", "#C5F5F5");
        document.documentElement.style.setProperty("--product-gradient-color1", "#DAFFFF");
        document.documentElement.style.setProperty("--product-gradient-color2", "#E8FFFF");
        document.documentElement.style.setProperty("--product-thumb-color", "#C5FFFF");
        
      }else if(floverClass=='sweet_strawberry'){
        document.documentElement.style.setProperty( "--primary-color", "#E00909");
        document.documentElement.style.setProperty( "--secondary-color", "#FFEDED");
        document.documentElement.style.setProperty( "--tertiary-color", "#FFFAFA");
        document.documentElement.style.setProperty( "--label-color", "#FFD6D6");
        document.documentElement.style.setProperty("--product-gradient-color1", "#FFEAF3");
        document.documentElement.style.setProperty("--product-gradient-color2", "#FFEAF3");
        document.documentElement.style.setProperty("--product-thumb-color", "#FFC4DC");
        
      }else if(floverClass=='fruit_punch'){
        document.documentElement.style.setProperty( "--primary-color", "#EF8225");
        document.documentElement.style.setProperty( "--secondary-color", "#FFF0E2");
        document.documentElement.style.setProperty( "--tertiary-color", "#FFF8F1");
        document.documentElement.style.setProperty("--label-color", "#FFDFC3");
        document.documentElement.style.setProperty("--product-gradient-color1", "#FFFCD9");
        document.documentElement.style.setProperty("--product-gradient-color2", "#FFFCD9" );
        document.documentElement.style.setProperty("--product-thumb-color", "#FFF5B8");
        
      }else if(floverClass=='lemonade_squeeze'){
        document.documentElement.style.setProperty(  "--primary-color", "#DD43A0");
        document.documentElement.style.setProperty(  "--secondary-color",  "#FEF0FF");
        document.documentElement.style.setProperty( "--tertiary-color", "#FFF7FF");
        document.documentElement.style.setProperty("--label-color", "#FDDAFF");
        document.documentElement.style.setProperty("--product-gradient-color1", "#FEE8FF");
        document.documentElement.style.setProperty("--product-gradient-color2", "#FEE8FF" );
        document.documentElement.style.setProperty("--product-thumb-color", "#EAD2FF");
        
      }else if(floverClass=='peach_rings'){
        document.documentElement.style.setProperty( "--primary-color", "#EE4712");
        document.documentElement.style.setProperty( "--secondary-color","#FFEFEB");
        document.documentElement.style.setProperty( "--tertiary-color","#FFF8F6");
        document.documentElement.style.setProperty("--label-color", "#FFD9CE");
        document.documentElement.style.setProperty("--product-gradient-color1", "#FFEDB9");
        document.documentElement.style.setProperty("--product-gradient-color2", "#FFEDB9");
        document.documentElement.style.setProperty("--product-thumb-color", "#FFECC0");
        
        
      }else if(floverClass=='watermelon_splash'){
        document.documentElement.style.setProperty("--primary-color", "#28B40C");
        document.documentElement.style.setProperty("--secondary-color", "#E2FFE8");
        document.documentElement.style.setProperty( "--tertiary-color","#F1FFF0");
        document.documentElement.style.setProperty("--label-color", "#C5FFCF");
            document.documentElement.style.setProperty("--product-gradient-color1", "#D3FFD7");
        document.documentElement.style.setProperty("--product-gradient-color2", "#D3FFD7");
        document.documentElement.style.setProperty("--product-thumb-color", "#D2FFD6");
        
      }else if(floverClass=='sleepy_strawberry'){*/
          document.documentElement.style.setProperty("--primary-color", "#660FC5");
          document.documentElement.style.setProperty("--secondary-color", "#F1E5FF");
          document.documentElement.style.setProperty( "--tertiary-color","#FBF7FF");
          document.documentElement.style.setProperty("--label-color", "#EEDEFF");
          document.documentElement.style.setProperty("--product-gradient-color1", "#D3FFD7");
          document.documentElement.style.setProperty("--product-gradient-color2", "#D3FFD7");
          document.documentElement.style.setProperty("--product-thumb-color", "#D2FFD6");
        //}
    }else{
      document.documentElement.style.setProperty( "--primary-color", "#00C3BD" );
      document.documentElement.style.setProperty( "--secondary-color", "#E5FFFF");
      document.documentElement.style.setProperty( "--tertiary-color", "#F7FFFF");
      document.documentElement.style.setProperty("--label-color", "#C5F5F5");
      document.documentElement.style.setProperty("--product-gradient-color1", "#DAFFFF");
      document.documentElement.style.setProperty("--product-gradient-color2", "#E8FFFF");
      document.documentElement.style.setProperty("--product-thumb-color", "#C5FFFF");
    }
    jQuery('body').removeClass(function (index, className) {
        return (className.match(/(^|\s)flover_\S+/g) || []).join(' ');
    });
    jQuery('body').addClass('flover_'+floverClass);
  }
}

function gummiesProductData(gummiesGet,price, servingprice, serviceDays){
  priceVariant=parseFloat(price);
  var gummiesStr = 'Gummies';
  if(jQuery('body').hasClass('product_monohydrate-powder')){
    var gummiesStr = 'Servings';
  }

  jQuery('.product_characteristic li').eq(1).text(gummiesGet+' '+gummiesStr);
  if(price!=undefined && price!=""){
    jQuery('.product_characteristic li').eq(0).text(servingprice+' / Serving');
    jQuery('.product_characteristic li').eq(2).text(serviceDays+'-Day Supply');
  }
}

function setGummiesServing() {
  var $productVariants = jQuery(".product-variant-custom").find("[name='Choose An Option To Save']");
  if ($productVariants.length === 0) {
    console.log('No product variants found!');
    return; // Exit early if no variants exist
  }
  $productVariants.each(function() {
    var $this = jQuery(this);
    var $parentDiv = $this.parent('div');
    var comparePrice = $parentDiv.find('.regular-price').attr('data-cprice');
    var price = $parentDiv.find('.vprice.sale-price').attr('data-price');
    var servindPrice = $parentDiv.find('.price-wrapper').attr('data-servingprice');
    
    var activePack = $this.val();
    if(servindPrice!="" && servindPrice!=undefined){
      $parentDiv.find('.variant-option-image .price-servings').text(servindPrice + '/serving');
    }
    
    // if(activePack!="" && activePack!=undefined){
    //   if (activePack !== undefined) {
    //     activePack = activePack.match(/\d+/);
    //     if (activePack !== null) {
    //       activePack = activePack[0];
    //     }
    //   }
      
    //   if (activePack !== undefined && price !== undefined) {
    //     price = parseFloat(price) / 100; // Convert price to float and divide by 100
    //     if(activePack == 2){
    //       activePack = 60;
    //     }
    //     if(activePack == 3){
    //       activePack = 90;
    //     }
    //     if(activePack == 4){
    //       activePack = 120;
    //     }
    //     var servingPricePack = parseFloat(price) / parseInt(activePack);
    //     console.log("servingPricePack",servingPricePack);
    //     if(servingPricePack!=undefined){
    //       var servingPrice = servingPricePack.toFixed(2);
    //       $parentDiv.find('.variant-option-image .price-servings').text(Shopify.formatMoney(servingPrice) + '/serving');
    //     }
    //     //$('.price-servings_variant').text(servingPrice + '/serving');
    //   }
    // }
  });
}

if(jQuery('body').hasClass("template-product")){
  setInterval(function(){
    progressBarProduct();
  },5000);
}
function progressBarProduct(){
  $.ajax({
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      if(cart.total_price>0){
        var totalPrice = cart.total_price;
        progressBar(totalPrice);
      }else{
        progressBar(0);
      }
    }
  });
}
function progressBar(totalPrice){
  jQuery('.sprogress-steps').find('.sprogress-item').removeClass('active');
  var atcAboveText = 0;
  if(jQuery('.shopify-app-block.recharge-subscription-widget').find('.subscription-radio.rc-radio--active').length>0){
    priceVariant = jQuery('.shopify-app-block.recharge-subscription-widget').find('.rc-radio.rc-radio--active').find('.rc-radio__price').text();
    if(priceVariant!=undefined){
      priceVariant = (parseFloat(priceVariant.replace(/[^0-9.]/g,''))*100);
    }
  }
  else if(jQuery('.shopify-app-block.recharge-subscription-widget').find('.onetime-radio.rc-radio--active').length>0){
    priceVariant = jQuery('.shopify-app-block.recharge-subscription-widget').find('.onetime-radio.rc-radio--active').find('.rc-radio__label').text();
    if(priceVariant!=undefined){
      priceVariant = (parseFloat(priceVariant.replace(/[^0-9.]/g,''))*100);
    }
  }
  totalPrice = (totalPrice+priceVariant);
  var goalAmt = (goalAmount*100);
  if(jQuery('[name="purchaseOption"]:checked').val()=='subscription'){
    jQuery('.product-section').find('.free-shipping-text.addmore-amt').hide();
    jQuery('.product-section').find('.free-shipping-text.free-ship').show();
    jQuery('.product-section').find('.progress-container.product-progress').find('.progress-bar').css('width','100%');
  }
  else if(totalPrice>=goalAmt){
    jQuery('.product-section').find('.free-shipping-text.addmore-amt').hide();
    jQuery('.product-section').find('.free-shipping-text.free-ship').show();
    jQuery('.product-section').find('.progress-container.product-progress').find('.progress-bar').css('width','100%');
  }
  else{
    var goal = shippingGoal; // Your goal amount
    var total = 100; // 100% width base
    let percentage = (totalPrice / goalAmount);
    // Update progress bar width and percentage text
    percentage = Math.round(percentage);
    totalPrice = (totalPrice/100);
    var totalRemainAmt = parseFloat(goalAmount-totalPrice);
    totalRemainAmt = (totalRemainAmt*100);
    jQuery('.product-section').find('.free-shipping-text.free-ship').hide();
    jQuery('.product-section').find('.free-shipping-text.addmore-amt').show();
    jQuery('.product-section').find('.free-shipping-text.addmore-amt').find('.amt-price').text(Shopify.formatMoney(totalRemainAmt));
    jQuery('.product-section').find('.progress-container.product-progress').find('.progress-bar').css('width',percentage+'%');
  }
  
}

//PRODUCT DETAILS PAGE FOR CHANGE VARIANT FOR ADD CLASS BODY AND DETAILS SOME CHANGES END

// FAQ POPUP -- START
jQuery(document).ready(function () {
  jQuery("a[title='#facts_popup']").on("click", function () {
    jQuery(".supplement_facts_popup").show();
    jQuery("body").addClass("supplement_facts__active");
  });

  jQuery(".sf_popup_close").on("click", function () {
    jQuery(".supplement_facts_popup").hide();
    jQuery("body").removeClass("supplement_facts__active");
  });
});
// FAQ POPUP -- END


// PRODUCT BENEFITS -- START
$(document).ready(function(){
  $('ul.bt_nav_tabs li').click(function(){
      var tab_id = $(this).attr('data-tab');
      var svgColor = $(this).attr('data-bgcolor');
      var svgPathColor = $(this).attr('data-strokecolor');
      if(svgColor!="" && svgColor!=undefined){
        if(jQuery('.product_benefits_section .section-type-product-benefits-blocks-shape').find('svg').length>0){
          jQuery('.product_benefits_section .section-type-product-benefits-blocks-shape').find('svg').css('background-color',svgColor);
        }
      }
      if(svgPathColor!="" && svgPathColor!=undefined){
        if(jQuery('.product_benefits_section .section-type-product-benefits-blocks-shape').find('svg path').length>0){
          jQuery('.product_benefits_section .section-type-product-benefits-blocks-shape').find('svg path').attr('fill',svgPathColor);
        }
      }
      $('ul.bt_nav_tabs li').removeClass('current');
      $('.product_benefits_tabcontent').removeClass('current');

      $(this).addClass('current');
      $("#"+tab_id).addClass('current');
  });
});
// PRODUCT BENEFITS -- END

//BLOG MOBILE SLIDER JS START 

$('.for-blog-mobile-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 99999,
          settings: "unslick"
        },
      {
        breakpoint: 768,
          settings: "slick",
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          infinite: false,
          arrows: false,
        }
      }
    ]
});

//BLOG MOBILE SLIDER JS END


//LOGO MARQUEE JS START 
$('.image_marquee_slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows:false,
  dots:false,
  responsive: [
    {
      breakpoint: 1240,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
//LOGO MARQUEE JS END 


// CART DRAWER PROGRESS -- START
var goalAmount_progress = jQuery('.cc-cart-progress').attr('data-goal-amount');
var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
setInterval(function(){
 if(jQuery('.drawer.active').length>0){
   jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      if(cartData.length>0){
        subTotal = cart.original_total_price;
        var percentage_reached = (eval(subTotal) / eval(goalAmount_progress));
        if(parseFloat(percentage_reached) > 100){
          var percentage_reached = 100;
        }
        jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
        jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
      
        jQuery('.cc-cart-progressbar').removeClass("progress-filled");
        jQuery('.cart_shipping_box').hide();
        if(percentage_reached == 100){
          jQuery('.cart_shipping_box').show();
          jQuery('.cc-cart-progressbar').addClass("progress-filled");
        }else{
          jQuery('.cart_shipping_box').hide();
        }
        
      
        var cartTotalFull = eval(subTotal) / 100;
        var tempStr = '';
        var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
        if(goalAmount_progress > cartTotalFull){
          var goalPendingAmount = (eval(goalAmount_progress) * 100) - subTotal;
          tempStr += goalBeforeText;
          tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
          tempStr += Shopify.formatMoney(goalPendingAmount);
          tempStr += '</span>'
          tempStr += goalAfterText;
        }
        else{
          tempStr += goalReachText;
          svg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M17.2523 5.25116C15.9303 5.17842 14.6188 5.52204 13.5023 6.23366C13.2323 5.92616 12.9548 5.61866 12.6623 5.32616L12.4448 5.12366L12.5498 5.03366C12.9166 4.71881 13.1779 4.29904 13.2986 3.83098C13.4193 3.36293 13.3936 2.86911 13.2248 2.41616C12.981 1.90479 12.5939 1.47523 12.1106 1.17966C11.6273 0.88409 11.0686 0.735227 10.5023 0.751157V2.25116C10.7691 2.24744 11.0321 2.31499 11.2642 2.44683C11.4962 2.57867 11.6889 2.77002 11.8223 3.00116C11.9498 3.30116 11.8223 3.63116 11.4698 3.98366L11.2973 4.14116C10.515 3.4893 9.65615 2.93521 8.73979 2.49116C6.84229 1.63616 5.86729 2.03366 5.38729 2.49116C5.24103 2.63777 5.12395 2.81084 5.04229 3.00116L4.90729 3.39866L3.82729 6.65366C4.68229 8.78366 6.75229 12.5712 11.2523 14.2062L15.0023 12.9612C15.1287 12.9141 15.2402 12.8338 15.3248 12.7287L15.4823 12.5937C16.5548 11.5137 15.8648 9.43616 14.4248 7.41866C15.2798 6.91965 16.2644 6.68722 17.2523 6.75116V5.25116ZM14.4098 11.5287H14.3648C13.8473 11.8062 11.7023 11.1012 9.27229 8.67116C9.01729 8.41616 8.77729 8.16866 8.55979 7.92116C8.48479 7.83866 8.41729 7.74866 8.34229 7.65866L7.94479 7.17866L7.73479 6.88616C7.62979 6.74366 7.52479 6.60116 7.43479 6.46616C7.34479 6.33116 7.31479 6.27116 7.25479 6.17366C7.19479 6.07616 7.08979 5.91866 7.02229 5.79116C6.95479 5.66366 6.92479 5.61116 6.87979 5.51366C6.83479 5.41616 6.75229 5.30366 6.70729 5.19866C6.66229 5.09366 6.63979 5.02616 6.60229 4.94366C6.56479 4.86116 6.51979 4.74116 6.48979 4.64366C6.45979 4.54616 6.45229 4.50116 6.43729 4.42616C6.42229 4.35116 6.39229 4.24616 6.37729 4.17116C6.37368 4.11121 6.37368 4.0511 6.37729 3.99116C6.36992 3.92637 6.36992 3.86095 6.37729 3.79616L6.45979 3.56366C6.58729 3.42866 7.14229 3.39116 8.13229 3.84116C8.7939 4.159 9.41991 4.54617 9.99979 4.99616C9.68366 5.13568 9.34659 5.22185 9.00229 5.25116V6.75116C9.79907 6.70595 10.5722 6.46371 11.2523 6.04616L11.6198 6.39116C11.9498 6.71366 12.2423 7.03616 12.5123 7.34366C12.0601 8.11476 11.8804 9.01558 12.0023 9.90116L13.5023 9.60866C13.4516 9.32591 13.4516 9.0364 13.5023 8.75366C14.4698 10.2312 14.6498 11.2962 14.4098 11.5287ZM3.30229 8.25116L1.62979 13.2762C1.50907 13.6451 1.47738 14.0373 1.53729 14.4209C1.59721 14.8044 1.74703 15.1683 1.97452 15.4828C2.20201 15.7974 2.5007 16.0536 2.84618 16.2306C3.19165 16.4076 3.57411 16.5003 3.96229 16.5012C4.21746 16.4987 4.47062 16.4556 4.71229 16.3737L9.60229 14.7462C6.84239 13.3366 4.62704 11.0527 3.30229 8.25116Z" fill="#042324"/></svg>';
        }
        jQuery('.cart__goal__message').html(tempStr);
        jQuery('.cc-cart-progress-heading .svg-html').html('');
        jQuery('.cc-cart-progress-heading .svg-html').html(svg);
      }
});
 }
},1000);
// CART DRAWER PROGRESS -- START



  
  getHeaderHeight();

  function getHeaderHeight(){
    var height = $(window).height();
    document.documentElement.style.setProperty('--header-height', height + 'px');
  }

  jQuery(document).on("click",".js-toggle-slide-nav",function(){  
    jQuery('body').addClass('menu-hidden');
  });
  jQuery(document).on("click",".slide-nav--close",function(){  
    jQuery(".js-toggle-slide-nav").removeClass("is-active");
    jQuery(".js-toggle-slide-nav").trigger("click");
    jQuery('.slide-nav__overflow--thumb').removeClass('is-transitioning');
    jQuery('body').removeClass('menu-hidden');
    jQuery('.drawer-nav ').removeClass('js-menu--is-open');
  });

jQuery(window).on('resize', function () {
  getHeaderHeight();
});

// Announcement Bar Start

jQuery(document).ready(function() {
 jQuery('.announcement .announcement__wrapper').slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="white" stroke-width="2" stroke-linecap="square"></path></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="white" stroke-width="2" stroke-linecap="square"></path></svg></button>',
  });
});

// Announcement Bar End

// CUSTOMER REVIEW JS START
$(document).ready(function() {
  $('.tpplay-icon').on('click', function () {
    var $icon = $(this);
    var $card = $icon.closest('.tr_col_banner');
    var $localVideo = $card.find('.tvideo');
    var $thumbnail = $card.find('.tthumbnail');

    // Hide play icon and thumbnail
    $icon.hide();
    $card.addClass('tr_col_banner-active');

    if ($thumbnail.length) {
      $thumbnail.hide();
    }
    if ($carddetails.length) {
      $carddetails.hide();
    }

    // Handle YouTube
    if($youtubeVideo.length) {
      $youtubeVideo.attr('src', $youtubeVideo.data('src') + '&autoplay=1&mute=1');
      $youtubeVideo.removeClass('lazyload').show();
      $youtubeVideo.trigger('click');
    }

    // Handle Vimeo
    else if ($vimeoVideo.length) {
      $vimeoVideo.attr('src', $vimeoVideo.data('src') + '&autoplay=1');
      $vimeoVideo.removeClass('lazyload').show();
    }

    // Handle Local video
    else if ($localVideo.length) {
      $localVideo.show().get(0).play();
    }
  });
  
});
jQuery(document).on('click','.br_banner_video', function() {
    var $video = jQuery(this).find('.tvideo');
    if (!$video.get(0).paused) {
      jQuery(this).parent().parent().parent('div').removeClass('tr_col_banner-active');
    }else{
      jQuery(this).parent().parent().parent('div').addClass('tr_col_banner-active');
    }
  });

// CUSTOMER REVIEW JS END




$(document).ready(function() {
      getAHeight();
  });
  function getAHeight(){
    var classaHeight = jQuery('.scrolling-announcement').height();
    var collectionBarHeight = jQuery('.product-bubble-section').height();
    document.documentElement.style.setProperty('--annoncement-height', classaHeight + 'px');
    document.documentElement.style.setProperty('--product-bubble-height', classaHeight + 'px');
  }
$(window).on('resize', function () {
      getAHeight();
  })


// OUR PRODUCT SLIDER JS START

$(document).ready(function(){
  $('.our_products_slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    prevArrow: $(".our_products_section .slider-button-wrapper .prev-button"),
    nextArrow: $(".our_products_section .slider-button-wrapper .next-button"),
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick" // disables slick on small screens
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
  });
});


// OUR PRODUCT SLIDER JS END

// Customer Reviews button js start
  jQuery(document).on("click", ".trusted_review_button", function () {
    jQuery('.trusted_review_section').toggleClass("review_load_more");
  });
// Customer Reviews button js end

// CARD HOVER JS -- START

$(document).ready(function () {
  $('.card-block-wrapper')
    .on('click', '.card-box-accordion', function () {
      $(this)                       // current card
        .addClass('hoverd')         // mark it
        .siblings('.card-box-accordion')
        .removeClass('hoverd');     // unmark all others
    });
});

// CARD HOVER JS -- END

// VIDEO SLIDER JS START FROM PDP PAGE
if($('.video-slider-section .video-wrapper').length>0){
  $('.video-slider-section .video-wrapper').each(function () {
    const $wrapper = $(this);
    const $video = $wrapper.find('video');

    // Skip if no video
    if (!$video.length) return;

    // Add custom play button
    const $playButton = $('<button class="custom-play-button"></button>');
    $wrapper.append($playButton);

    const togglePlay = function () {
      // Pause all other videos
      $('.video-slider-section video').each(function () {
        if (this !== $video[0]) {
          this.pause();
          $(this).parent().removeClass('video-playing');
          $(this).siblings('.custom-play-button').removeClass('playing');
        }
      });

      // Play or pause this video
      if ($video[0].paused) {
        $video[0].play().then(() => {
          $playButton.addClass('playing');
          $wrapper.addClass('video-playing');
        }).catch(err => {
          console.warn('Autoplay blocked:', err);
        });
      } else {
        $video[0].pause();
        $playButton.removeClass('playing');
        $wrapper.removeClass('video-playing');
      }
    };

    // Event bindings
    $playButton.on('click', function () {
      setTimeout(togglePlay, 100); // slight delay after slide scroll
    });

    $video.on('click', togglePlay);

    $video.on('ended', function () {
      $playButton.removeClass('playing');
      $wrapper.removeClass('video-playing');
    });
  });
}